// src/pages/admin/AddJob.js
import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Textarea } from "@mui/joy";
import { Button as MuiButton } from '@mui/material';

export default function AddJob() {
  const navigate = useNavigate();
  const token    = localStorage.getItem("token");
  const headers  = { Authorization: `Bearer ${token}` };

  const [job, setJob] = useState({
    jobNumber: "",
    description: "",
    active: true
  });

  const createJob = async () => {
    if (!job.jobNumber) {
      alert("Please enter a Job Number");
      return;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}common/jobs`,
        job,
        { headers }
      );
      alert("Job created!");
      navigate("/jobs-list");
    } catch (e) {
      alert(e.response?.data?.message || "Error creating job");
    }
  };

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center mb-3">
        <Grid size={{ xs: 12, md: 6 }}><Breadcrumb title="Add Job" /></Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/jobs-list">
            <MuiButton variant="contained" color="secondary">Jobs List</MuiButton>
          </Link>
        </Grid>
      </Grid>
      <Box className="mc-card">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }} className="mb-3">
            <CardHeader title="Job Number" />
            <TextField
              fullWidth
              value={job.jobNumber}
              onChange={e => setJob({...job, jobNumber: e.target.value})}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 8 }} className="mb-3">
            <CardHeader title="Description" />
            <Textarea
              fullWidth
              minRows={1.7}
              value={job.description}
              onChange={e => setJob({...job, description: e.target.value})}
            />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 4 }} className="mb-3">
            <CardHeader title="Active" />
            <TextField
              select fullWidth
              value={job.active.toString()}
              onChange={e => setJob({...job, active: e.target.value==="true"})}
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </TextField>
          </Grid> */}
        </Grid>
        <Grid container spacing={2} className="mt-3">
          <Grid size={12} className="text-end">
            <MuiButton variant="contained" color="primary" onClick={createJob}>
              Create Job
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
  );
}
